import { QRCodeSVG } from 'qrcode.react';

interface QrPosterProps {
  title: string;
  subtitle: string;
  /** Der tenantweite Check-in-Link — sowohl QR-Inhalt als auch lesbar unter dem Code. */
  url: string;
}

/**
 * Druckbares A4-Poster für den Guest-Check-in. Feste A4-Maße (mm) und
 * `print-color-adjust: exact`, damit Bildschirm-Vorschau und Ausdruck identisch sind.
 * Rein präsentational, keine Persistenz — Titel/Begleittext kommen als Props.
 */
export function QrPoster({ title, subtitle, url }: QrPosterProps) {
  return (
    <div
      data-qr-poster
      className="flex flex-col items-center justify-between bg-white text-center text-[#141a1b]"
      style={{
        width: '210mm',
        height: '297mm',
        padding: '26mm 20mm',
        printColorAdjust: 'exact',
        WebkitPrintColorAdjust: 'exact',
      }}
    >
      <header className="flex flex-col items-center">
        <p
          className="font-mono font-semibold uppercase text-[#a0301f]"
          style={{ fontSize: '11pt', letterSpacing: '0.22em' }}
        >
          StayOn · Check-in
        </p>
        <div
          style={{ width: '28mm', height: '2px', margin: '6mm 0 10mm', background: '#a0301f' }}
        />
        <h1 className="font-serif" style={{ fontSize: '34pt', lineHeight: 1.1, margin: 0 }}>
          {title}
        </h1>
        <p
          className="font-sans text-[#5a5648]"
          style={{ fontSize: '14pt', lineHeight: 1.5, margin: '8mm 0 0', maxWidth: '150mm' }}
        >
          {subtitle}
        </p>
      </header>

      <div
        className="flex flex-col items-center"
        style={{ borderColor: '#e4d9bc', borderWidth: '1px', borderRadius: '4mm', padding: '10mm' }}
      >
        <QRCodeSVG value={url} size={340} level="M" marginSize={0} />
        <p className="font-mono text-[#5a5648]" style={{ fontSize: '10pt', marginTop: '6mm' }}>
          {url}
        </p>
      </div>

      <p className="font-sans text-[#5a5648]" style={{ fontSize: '12pt', maxWidth: '150mm' }}>
        Scannen Sie den Code mit der Kamera Ihres Smartphones, um den Check-in zu starten.
      </p>
    </div>
  );
}
